import React from 'react';
import { useLanguage } from '../i18n/LanguageProvider';

interface LoadingComponentProps {
  message?: string;
}

const LoadingComponent: React.FC<LoadingComponentProps> = ({ message }) => {
  const { t } = useLanguage();
  const displayMessage = message ?? t('loadingPayment');

  return (
    <div className="pp-loading-wrap">
      <div className="pp-loading-card">
        <div className="pp-loading-spinner" />
        <div className="pp-loading-text">{displayMessage}</div>
      </div>
    </div>
  );
};

export default LoadingComponent;